export default __webpack_public_path__ + "static/media/nav-mobile.49c1ee77.webp";